import { View, Views } from "react-big-calendar";

export const CUSTOM_VIEWS = {
  ...Views,
  TIMELINE: "timeline" as View,
  LIST: "list" as View,
  FRONT_DESK: "front_desk" as View
};

export const allDaysOptions = [
  { key: "1", text: "1 day" },
  { key: "2", text: "2 days" },
  { key: "3", text: "3 days" },
  { key: "4", text: "4 days" },
  { key: "5", text: "5 days" }
];
